import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import HiddenMobile from '../../../../shared/styles/HiddenMobile'
import SubHeader from '../../../../shared/styles/Subheader'
import { clientThemeV5 } from '../../../../shared/styles/themes/ClientTheme'

const FavoritesHeader = () => {
  const { t } = useTranslation(['global'])

  return (
    <>
      <Header title="Mis Favoritos" />
      <HiddenMobile>
        <SubHeader />
      </HiddenMobile>
      <HiddenDesktop>
        <Box
          textAlign="center"
          mb={1}
          pt={9}
          pb={3}
          borderRadius="0px 0px 24px 24px"
          boxShadow="0px 6px 20px rgba(0, 0, 0, 0.07)"
          color={clientThemeV5.palette.common.white}
          sx={{ backgroundColor: clientThemeV5.palette.primary.main }}
        >
          <Typography variant="h5">{t('my-favorites')}</Typography>
        </Box>
      </HiddenDesktop>
      <HiddenMobile>
        <ButtonBack />
      </HiddenMobile>
    </>
  )
}

export default FavoritesHeader
